<template>
  <article v-if="id" class="single-event-block">
    <WpLink
      class="event-block-link"
      v-if="postData"
      :title="postData.title.rendered.decodeHtmlEntities()"
      :url="postData.link"
    >
      <div v-if="isEventPast" class="past-label">
        {{ i18n.past_event_label }}
      </div>
      <wpImage
        v-if="postData.featured_image_src"
        :data="postData.featured_image_src"
        size="extra_large"
        class="event-thumb"
        insideclass="picture_demension picture_demension--16x9"
        lazy
        background
        placeholder
      />
      <div v-else class="event-thumb"></div>
      <div class="event-footer">
        <div class="column left padding_large">
          <ModuleHeading :level="3">{{
            postData.title.rendered.decodeHtmlEntities()
          }}</ModuleHeading>
          <Categories
            v-if="postData.acf._categories"
            :title="false"
            :categories="postData.acf._categories"
            taxonomy="event_cat"
            :link="false"
          />
        </div>
        <div class="column right padding_large">
          <EventMeta :id="id" :link="false" />
        </div>
      </div>
    </WpLink>
  </article>
  <div v-else class="single-event-block dummy">
    <div class="event-block-link">
      <div class="event-thumb"></div>
      <div class="event-footer ">
        <div class="column left">
          <div class="dummy-text ">
            <span></span>
            <span></span>
          </div>
          <div class="dummy-tags ">
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="column right">
          <div class="dummy-text ">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import Categories from "@/components/blocks/CategoriesBlock";
import EventMeta from "@/components/blocks/EventMeta";
import WpLink from "@/components/elements/WpLink";

import { isPastEvent } from "@/plugins/helpers";

import { mapGetters } from "vuex";

export default {
  name: "block-single-event",
  props: ["id"],
  components: {
    WpImage,
    Categories,
    EventMeta,
    WpLink
  },
  computed: {
    ...mapGetters(["getPageById"]),
    isEventPast() {
      return this.postData ? isPastEvent(this.postData) : null;
    },
    postData() {
      let post = null;
      if (this.id) {
        post = this.getPageById(this.id);
      }
      return post;
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.single-event-block {
  width: 100%;
  .past-label {
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    padding: 6px 12px;
    background-color: $dark;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 90;
  }
  .event-block-link {
    display: block;
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    transition: box-shadow 0.12s ease-in-out;
    &:hover {
      box-shadow: 0 0 10px 0 rgba(74, 79, 85, 0.5);
    }
  }
  .categories-block {
    border-bottom: none;
    margin: 0;
    padding: 0;
  }
  .dummy-text span,
  .dummy-tags span {
    background: linear-gradient(
      126deg,
      #c8c8c8 0%,
      #fff 40%,
      #fff 60%,
      #c8c8c8 100%
    );
  }
  .right {
    text-align: right;
    .dummy-text span {
      margin: 10px 0;
      height: 10px;
      float: right;
      width: 63%;
      &:nth-child(2) {
        width: 44%;
      }
      &:nth-child(3) {
        width: 58%;
      }
    }
  }
  .event-footer {
    background: rgba(#2a2e34, 0.75);
    padding: 0;
    z-index: 10;
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    color: #fff;
    align-items: flex-end;
    .column {
      max-width: 50%;
      width: 100%;
      .block-event-meta {
        background-color: transparent;
        padding: 0;
      }
    }
  }
  .event-thumb {
    position: absolute;
    top: 0;
    z-index: 1;
    margin: 0;
    @extend %preloadBgLight;
    left: 0;
    bottom: 0;
    right: 0;
    .picture_demension {
      height: 0;
      display: block;
      &.picture_demension--square,
      &.picture_demension--1x1 {
        padding-bottom: 100%;
      }

      &.picture_demension--4x3 {
        padding-bottom: 75%;
      }
      &.picture_demension--3x4 {
        padding-bottom: 133%;
      }

      &.picture_demension--16x9 {
        padding-bottom: 56.25%;
      }
      figure,
      .lazyloading,
      .bg-image {
        padding-bottom: inherit;
        background-size: cover;
        background-position: center center;
        position: relative;
        z-index: 2;
      }
      &.picture_demension--none {
        padding-bottom: auto;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        figcaption {
          display: none;
        }
        figure,
        .lazyloading,
        .bg-image {
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          position: absolute;
          background-size: cover;
          background-position: center center;
        }
      }
    }
  }
}
</style>
